/* Fontis demo - scripted guided-selling assistant (no API calls, no keys) */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var chat = $("#chat"), log = $("#chat-log"), form = $("#chat-in"), input = $("#chat-text");
  if (!chat) return;
  var CAT = window.CATALOG || [], byId = {}; CAT.forEach(function (p) { byId[p.id] = p; });
  var eur = function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €"; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var S, queue = Promise.resolve(), started = false;
  function reset() { S = { seg: "", room: "", flue: "", m2: 0, fuel: "", budget: "", bmax: 0, recs: [], expect: "", guard: false, ctx: "" }; }
  reset();

  /* ------------- rendering */
  function scroll() { log.scrollTop = log.scrollHeight + 200; }
  function add(html, who, cls) {
    var d = document.createElement("div"); d.className = (who === "me" ? "msg me" : "msg bot") + (cls ? " " + cls : "");
    d.innerHTML = html; log.appendChild(d); scroll(); return d;
  }
  function block(el) { log.appendChild(el); scroll(); return el; }
  function say(msgs, after) {
    msgs = [].concat(msgs);
    msgs.forEach(function (m) {
      queue = queue.then(function () {
        return new Promise(function (res) {
          var t = document.createElement("div"); t.className = "typing"; t.innerHTML = "<i></i><i></i><i></i>"; block(t);
          var txt = typeof m === "string" ? m : (m.html || "");
          var delay = Math.min(1100, 420 + txt.replace(/<[^>]+>/g, "").length * 7);
          setTimeout(function () {
            t.remove();
            if (typeof m === "string") add(m);
            else if (m.el) block(m.el());
            else add(m.html, "bot", m.cls);
            res();
          }, delay);
        });
      });
    });
    if (after) queue = queue.then(function () { after(); });
    return queue;
  }
  function me(t) { add(esc(t), "me"); }
  function clearChips() { Array.prototype.slice.call(log.querySelectorAll(".qr")).forEach(function (q) { q.remove(); }); }
  function chips(opts, noHuman) {
    queue = queue.then(function () {
      clearChips();
      var q = document.createElement("div"); q.className = "qr";
      opts.forEach(function (o) {
        var b = document.createElement("button"); b.type = "button"; b.textContent = o.t; if (o.c) b.className = o.c;
        b.addEventListener("click", function () { clearChips(); if (!o.silent) me(o.t); o.f(); });
        q.appendChild(b);
      });
      if (!noHuman) {
        var h = document.createElement("button"); h.type = "button"; h.className = "human"; h.textContent = "Hablar con una persona";
        h.addEventListener("click", function () { clearChips(); me("Quiero hablar con una persona"); handoff(); });
        q.appendChild(h);
      }
      block(q);
    });
  }
  function src(t) { return '<div class="srcline">&#128196; ' + t + "</div>"; }

  /* ------------- open / close */
  function open(q) {
    chat.classList.add("open"); chat.setAttribute("aria-hidden", "false");
    if (window.matchMedia("(max-width:699px)").matches) document.documentElement.style.overflow = "hidden";
    var n = $("#nudge"); if (n) n.classList.remove("on");
    if (!started) { started = true; start(q); } else if (q) context(q);
    setTimeout(function () { if (!window.matchMedia("(max-width:699px)").matches) input.focus(); }, 300);
  }
  function close() { chat.classList.remove("open"); chat.setAttribute("aria-hidden", "true"); document.documentElement.style.overflow = ""; }
  window.IFAssistant = { open: open, close: close };
  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-open-assistant]");
    if (o) {
      e.preventDefault();
      var l = o.closest(".drawer.open, .modal.open, .sheet.open"); if (l && window.IFclose) window.IFclose(l);
      open(o.getAttribute("data-q") || "");
      return;
    }
    if (e.target.closest("[data-chat-close]")) close();
    if (e.target.closest("[data-chat-reset]")) { log.innerHTML = ""; reset(); queue = Promise.resolve(); started = true; start(""); }
    if (e.target.closest("[data-human]")) { clearChips(); me("Quiero hablar con una persona"); handoff(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && chat.classList.contains("open")) close(); });

  /* ------------- flow */
  function start(q) {
    var d = document.createElement("div"); d.className = "disclose";
    d.innerHTML = "Estás hablando con una <b>inteligencia artificial</b>. En instalación y seguridad solo responde con la documentación de cada fabricante y te pasa con una persona cuando hace falta.";
    block(d);
    if (q && q !== "buscar") {
      say("¡Hola! Soy el asistente de IA de Intelligent Fire.");
      context(q); return;
    }
    say(["¡Hola! Soy el asistente de IA de Intelligent Fire.",
      q === "buscar" ? "Dime qué buscas: un modelo (FLA4, Neo, Astro...) o cuéntame tu espacio y te propongo 2-3 chimeneas en 60 segundos."
        : "Te ayudo a elegir chimenea en 60 segundos, con los datos técnicos de cada fabricante. Y cuando quieras, te paso con una persona del equipo."]);
    chips([
      { t: "Soy particular", f: function () { S.seg = "Particular"; askRoom(); } },
      { t: "Soy profesional (arquitecto, interiorista, hotel)", f: pro },
      { t: "¿Cuánto consume?", c: "faq", f: consumo },
      { t: "¿Se puede instalar sin ventilación?", c: "faq", f: guard }
    ]);
  }
  function context(q) {
    S.ctx = q;
    if (q === "seguridad") { me("¿Es segura una chimenea de bioetanol?"); safety(); return; }
    if (q === "cabe") { S.seg = S.seg || "Particular"; S.fuel = "bioetanol"; say("Vamos a comprobarlo con la ficha técnica del Neo Fireplace 1000. ¿Cuántos m² tiene tu salón, más o menos?"); m2chips(); return; }
    if (q === "proyecto") { S.seg = S.seg || "Particular"; S.fuel = "bioetanol"; say("Te ayudo con tu proyecto FLA4. Para empezar: ¿qué superficie tiene la estancia?"); m2chips(); return; }
    if (q === "comparar") { say("Te ayudo a decidir. Primero, tu espacio:"); askRoom(); return; }
    if (q.indexOf("modelo:") === 0) { modelInfo(byId[q.slice(7)]); return; }
    askRoom();
  }
  function pro() {
    S.seg = "Profesional";
    say("¡Genial! Trabajamos a diario con estudios de arquitectura e interiorismo. ¿Qué necesitas ahora?");
    chips([
      { t: "Fichas y planos CAD", f: function () { say({ html: 'Tienes fichas, DWG 2D y manuales oficiales de los fabricantes en la <a href="/pages/profesionales#biblioteca"><b>biblioteca profesional</b></a>. Los modelos BIM los enviamos bajo pedido en 24 h.' }); more(); } },
      { t: "Precio profesional", f: function () { say({ html: 'Los precios de estudio se ven tras validar tu cuenta (24 h laborables). <a href="/pages/profesionales#acceso"><b>Solicitar acceso profesional</b></a>.' }); more(); } },
      { t: "Tengo un proyecto ahora", f: function () { S.room = "Proyecto profesional"; say("Perfecto. Te hago 3 preguntas y te propongo modelos para el proyecto."); askFlue(); } }
    ]);
  }
  function askRoom() {
    S.expect = "room";
    say("¿Dónde quieres la chimenea?");
    chips([
      { t: "Salón o comedor", f: function () { S.room = "Salón"; askFlue(); } },
      { t: "Dormitorio", f: function () { S.room = "Dormitorio"; askFlue(); } },
      { t: "Terraza o jardín", f: function () { S.room = "Exterior"; S.flue = "No aplica"; S.fuel = "gas"; say("Para exterior tenemos modelos de gas (natural o GLP). Los instala siempre un instalador habilitado."); askBudget(); } },
      { t: "Hotel, restaurante u oficina", f: function () { S.room = "Comercial"; S.seg = S.seg === "Profesional" ? S.seg : "Comercial"; askFlue(); } }
    ]);
  }
  function askFlue() {
    S.expect = "flue";
    say("¿Tienes chimenea o salida de humos en esa estancia?");
    var next = function (v, t) { S.flue = v; say(t); askM2(); };
    chips([
      { t: "No tengo", f: function () { next("No", "Sin problema: ninguna de las chimeneas que te voy a proponer necesita salida de humos."); } },
      { t: "Sí tengo", f: function () { next("Sí", "Perfecto, aunque no la vas a necesitar: estas chimeneas no usan salida de humos, así que puedes ponerla donde quieras."); } },
      { t: "No lo sé", f: function () { next("No lo sé", "No pasa nada: estas chimeneas no necesitan salida de humos, así que no condiciona la elección."); } }
    ]);
  }
  function m2chips() {
    S.expect = "m2";
    chips([
      { t: "Hasta 20 m²", f: function () { setM2(18); } }, { t: "20-35 m²", f: function () { setM2(28); } },
      { t: "35-60 m²", f: function () { setM2(45); } }, { t: "Más de 60 m²", f: function () { setM2(70); } }
    ]);
  }
  function askM2() { say("¿Cuántos m² tiene la estancia, más o menos? Puedes escribir el número."); m2chips(); }
  function setM2(v) {
    S.m2 = v; S.expect = "";
    var m3 = Math.round(v * 2.5);
    if (S.ctx === "cabe") {
      var ok = m3 >= 59;
      say({ html: "<p>Con unos " + v + " m² y techo de 2,5 m, tu salón tiene unos <b>" + m3 + " m³</b>.</p><p>" + (ok ? "<b>Cumple</b> el volumen mínimo del Neo Fireplace 1000 (59 m³). Necesitas además renovar 1 volumen de aire por hora y un enchufe de 230 V." : "El Neo Fireplace 1000 pide <b>59 m³</b>, así que no te lo recomiendo. El <b>Neo Fireplace 750</b> pide 41 m³" + (m3 >= 41 ? " y sí encaja." : ".") ) + "</p>" + src("Ficha técnica Planika Neo 1000 Single-Sided, p. 2") });
      chips(ok ? [{ t: "Añadir Neo 1000 al carrito", f: function () { close(); var b = document.querySelector("[data-add='neo-1000']"); if (b) b.click(); else location.href = "/products/neo-1000"; } }, { t: "Presupuesto con instalación", f: function () { askLead("WhatsApp"); } }]
        : [{ t: "Ver Neo 750", f: function () { close(); location.href = "/products/neo-750"; } }, { t: "Ver otras opciones", f: function () { S.ctx = ""; askFuel(); } }]);
      return;
    }
    if (S.ctx === "proyecto") {
      var ok2 = m3 >= 130;
      say({ html: "<p>Con unos " + v + " m² y 2,5 m de altura: <b>" + m3 + " m³</b>.</p><p>" + (ok2 ? "Encaja con la FLA4 1490, que pide <b>130 m³</b> y da 13 kW." : "La FLA4 1490 pide <b>130 m³</b>. Para tu espacio te propondría la <b>FLA4 990</b> o un <b>Prime Fire 2.0</b>, o subir la altura si es doble altura.") + "</p>" + src("Ficha técnica Planika FLA4 1490, p. 2") });
      chips([{ t: "Reservar consulta de diseño", f: function () { close(); location.href = "/products/fla4-1490#consulta"; } }, { t: "Presupuesto por WhatsApp", f: function () { askLead("WhatsApp"); } }]);
      return;
    }
    say("Unos " + m3 + " m³ con techo de 2,5 m. Lo tengo en cuenta: cada chimenea de bioetanol pide un volumen mínimo.");
    askFuel();
  }
  function askFuel() {
    S.expect = "fuel";
    say("¿Qué tipo de fuego te imaginas?");
    chips([
      { t: "Llama real (bioetanol)", f: function () { S.fuel = "bioetanol"; askBudget(); } },
      { t: "Eléctrica: enchufar y listo", f: function () { S.fuel = "electrica"; askBudget(); } },
      { t: "Vapor de agua: sin calor", f: function () { S.fuel = "vapor"; askBudget(); } },
      { t: "Aconséjame", f: function () { S.fuel = "any"; say("Te propongo lo que mejor encaje por metros y presupuesto."); askBudget(); } }
    ]);
  }
  function askBudget() {
    S.expect = "budget";
    say("Última pregunta: ¿qué presupuesto manejas, con instalación? Puedes pagarlo en hasta 36 meses.");
    var b = function (t, max) { return { t: t, f: function () { S.budget = t; S.bmax = max; recommend(); } }; };
    chips([b("Hasta 2.500 €", 2500), b("2.500-5.000 €", 5000), b("5.000-10.000 €", 10000), b("Más de 10.000 €", 99999), b("Prefiero no decirlo", 0)]);
  }
  function recommend() {
    S.expect = "";
    var m3 = S.m2 ? Math.round(S.m2 * 2.5) : 0;
    var pool = CAT.filter(function (p) {
      if (S.room === "Exterior") return p.inst === "exterior";
      if (p.inst === "exterior") return false;
      if (S.fuel && S.fuel !== "any" && p.fuel !== S.fuel) return false;
      if (m3 && p.m3 && m3 < p.m3) return false;
      return true;
    });
    var within = pool.filter(function (p) { return !S.bmax || p.price <= S.bmax * 1.05; });
    if (!within.length) within = pool.slice().sort(function (a, b) { return a.price - b.price; });
    var target = S.bmax ? Math.min(S.bmax, 30000) : 5000;
    within.sort(function (a, b) {
      var sa = Math.abs(target * 0.85 - a.price) - (a.m3 && m3 ? 400 : 0) - (a.url && a.url[0] === "/" ? 600 : 0);
      var sb = Math.abs(target * 0.85 - b.price) - (b.m3 && m3 ? 400 : 0) - (b.url && b.url[0] === "/" ? 600 : 0);
      return sa - sb;
    });
    var recs = within.slice(0, 3); S.recs = recs.map(function (p) { return p.name; });
    say(recs.length ? "Con lo que me cuentas, estas son mis propuestas:" : "No tengo un modelo que cumpla todo. Te paso con una persona para buscar alternativas.");
    if (!recs.length) { handoff(); return; }
    say({ el: function () {
      var w = document.createElement("div"); w.className = "recs";
      recs.forEach(function (p, i) {
        var why = [];
        if (p.m3 && m3) why.push("Pide " + p.m3 + " m³ y tu estancia tiene ~" + m3 + " m³");
        if (p.inst === "sin-obra") why.push("Sin obra: la colocas y la enciendes");
        if (p.inst === "encastrable" && p.fuel !== "electrica") why.push("Encastrable en pared o mueble, sin salida de humos");
        if (p.fuel === "electrica") why.push("Solo necesita un enchufe");
        if (p.fuel === "vapor") why.push("Vapor de agua frío: segura con niños");
        if (p.inst === "exterior") why.push("Para exterior, a gas");
        if (p.app) why.push("Control por app y mando");
        if (S.bmax && p.price <= S.bmax) why.push("Dentro de tu presupuesto: " + p.mo + " €/mes");
        if (p.mode === "project") why.push("Proyecto a medida con visita técnica");
        var a = document.createElement("a"); a.className = "rec"; a.href = p.url;
        if (p.url[0] === "#") a.addEventListener("click", function (e) { e.preventDefault(); close(); if (window.IFquick) window.IFquick(p.id); });
        a.innerHTML = '<img src="' + p.img + '" alt=""><div>' + (i === 0 ? '<span class="top">Mejor opción</span>' : "") + "<b>" + p.name + '</b><div class="pr">' + (p.frm ? "Desde " : "") + eur(p.price) + " <small>o " + p.mo + " €/mes</small></div><ul>" + why.slice(0, 3).map(function (x) { return "<li>" + x + "</li>"; }).join("") + "</ul></div>";
        w.appendChild(a);
      });
      return w;
    } });
    say("¿Te envío esta comparativa con el precio de instalación por WhatsApp? Una persona del equipo técnico la revisa antes de mandártela.");
    chips([
      { t: "Sí, por WhatsApp", f: function () { askLead("WhatsApp"); } },
      { t: "Mejor por email", f: function () { askLead("Email"); } },
      { t: "Reservar videoconsulta", f: function () { askLead("Videollamada"); } }
    ]);
  }
  function askLead(channel) {
    say(channel === "Email" ? "Perfecto. Déjame tu nombre y email:" : "Perfecto. Déjame tu nombre y teléfono y te escribimos en menos de 1 hora (L-V 9-19 h):");
    say({ el: function () {
      var f = document.createElement("form"); f.className = "chat-form";
      f.innerHTML = '<input class="input" name="n" placeholder="Nombre" required autocomplete="given-name">' +
        (channel === "Email" ? '<input class="input" name="c" type="email" placeholder="Email" required autocomplete="email">' : '<input class="input" name="c" type="tel" placeholder="Teléfono (WhatsApp)" required autocomplete="tel">') +
        '<input class="input" name="cp" placeholder="Código postal (para asignar instalador)" inputmode="numeric">' +
        '<label class="check"><input type="checkbox" required> Acepto la política de privacidad y que me contactéis por ' + channel + ".</label>" +
        '<button class="btn btn-ember btn-block btn-sm">Enviar</button>';
      f.addEventListener("submit", function (e) {
        e.preventDefault(); if (!f.checkValidity()) { f.reportValidity(); return; }
        var n = f.n.value.trim(); f.remove(); me(n + " · " + f.c.value);
        done(channel, n, f.cp.value, f.c.value.trim());
      });
      return f;
    } });
  }
  function done(channel, name, cp, contact) {
    say("¡Hecho, " + esc(name) + "! " + (channel === "Videollamada" ? "Te escribimos para fijar la hora de la videoconsulta y te mandamos el enlace." : "Una persona del equipo técnico te escribe por " + channel + " en menos de 1 hora (L-V 9-19 h). Fuera de horario, a primera hora."));
    var rows = [["Segmento", S.seg || "Particular"], ["Espacio", S.room || "-"], ["Salida de humos", S.flue || "-"], ["Superficie", S.m2 ? S.m2 + " m²" : "-"],
      ["Combustible", { bioetanol: "Bioetanol", electrica: "Eléctrica", vapor: "Vapor de agua", gas: "Gas", any: "Sin preferencia" }[S.fuel] || "-"], ["Presupuesto", S.budget || "-"],
      ["Recomendados", S.recs.join(", ") || "-"]];
    if (S.guard) rows.push(["Alerta", "Pregunta de seguridad derivada a técnico"]);
    var conv = AIH.slice(-6).map(function (m) { return (m.role === "user" ? "Cliente: " : "IA: ") + m.content.replace(/\[Contexto de la web:[^\]]*\]\s*/, "").replace(/\[\[[^\]]*\]\]/g, "").slice(0, 400); }).join(" || ");
    if (window.IFsendLead) window.IFsendLead({ oferta: "asistente-ia", nombre: name, telefono: channel === "Email" ? "" : contact, email: channel === "Email" ? contact : "",
      provincia: cp || "", canal: channel, espacio: S.room || "", presupuesto: S.budget || "", calidad: S.bmax && S.bmax < 3000 ? "presupuesto_bajo" : "cualificado",
      mensaje: rows.filter(function (r) { return r[1] !== "-"; }).map(function (r) { return r[0] + ": " + r[1]; }).join(" | ") + (conv ? " || Conversación: " + conv : "") });
    more();
  }
  function waSummary(name) {
    var t = "Hola, soy " + (name || "") + ". Vengo del asistente de la web.\n" +
      (S.room ? "Espacio: " + S.room + (S.m2 ? " (" + S.m2 + " m²)" : "") + "\n" : "") +
      (S.budget ? "Presupuesto: " + S.budget + "\n" : "") + (S.recs.length ? "Me interesan: " + S.recs.join(", ") + "\n" : "") + "¿Me pasáis precio con instalación?";
    if (window.IFwa) window.IFwa(t);
  }
  function handoff() {
    say("Claro. Una persona del equipo técnico te atiende en horario L-V 9-19 h. ¿Cómo prefieres?");
    chips([
      { t: "WhatsApp ahora", f: function () { say("Te paso a WhatsApp con el resumen de esta conversación, para que no tengas que repetir nada."); queue = queue.then(function () { waSummary(""); }); more(); } },
      { t: "Que me llamen", f: function () { askLead("Teléfono"); } },
      { t: "Videollamada", f: function () { askLead("Videollamada"); } }
    ], true);
  }
  function more() {
    chips([{ t: "Elegir chimenea", f: function () { S.ctx = ""; askRoom(); } }, { t: "Tengo otra pregunta", f: function () { say("Claro, escríbemela."); } }]);
  }

  /* ------------- grounded answers */
  function guard() {
    S.guard = true;
    say({ cls: "guard", html: "<p>Te respondo solo con lo que dice la documentación del fabricante:</p><p>• Las chimeneas de bioetanol necesitan <b>renovar 1 volumen de aire de la estancia por hora</b>.<br>• Cada modelo pide un <b>volumen mínimo</b>: 41 m³ el Neo 500 y 750, 59 m³ el Neo 1000 y 130 m³ la FLA4 1490.</p><p><b>No puedo confirmarte que se pueda instalar en una estancia sin ventilación.</b> Eso lo valora un técnico con tus medidas.</p>" + src("Fichas técnicas Planika Neo 1000 y FLA4 1490 (2025-2026)") });
    say("Te paso con una persona del equipo técnico. Si no hay ventilación, una chimenea eléctrica o de vapor de agua puede ser la alternativa.");
    chips([
      { t: "Hablar con un técnico", f: handoff },
      { t: "Ver eléctricas", f: function () { location.href = "/collections/chimeneas-electricas"; } },
      { t: "Ver vapor de agua", f: function () { location.href = "/collections/vapor-de-agua"; } }
    ], true);
  }
  function consumo() {
    say({ html: "<p>Según los datos del fabricante, un quemador de <b>1 metro consume aproximadamente 1 litro de bioetanol por hora</b>. Con el bioetanol a unos 4,5 €/L, son unos <b>4,5 € por hora</b> de fuego.</p><p>Los quemadores automáticos BEV gastan hasta un 20 % menos que los manuales. Una eléctrica consume lo que su resistencia: 1,5 o 3 kW.</p>" + src("Ficha del fabricante: bioetanol Fanola (Planika)") });
    more();
  }
  function safety() {
    say({ html: "<p>Los modelos automáticos con quemador BEV usan la <b>tecnología BEV</b>: calientan el bioetanol en un depósito aislado y queman solo sus vapores. La llama nunca toca el líquido.</p><p>Llevan sensores de temperatura, de nivel de combustible y de derrame, bloqueo infantil, y se llenan con una bomba que se para sola. Sin humo, sin olor y sin cenizas.</p>" + src("Documentación técnica del fabricante (Planika FLA4 y Neo)") });
    more();
  }
  function modelInfo(p) {
    if (!p) { askRoom(); return; }
    say({ html: "<p><b>" + p.name + "</b> (" + p.brand + " " + p.fam + "). " + esc(p.note) + "</p><p>" + p.chips.join(" · ") + ". " + (p.frm ? "Desde " : "") + eur(p.price) + " o " + p.mo + " €/mes.</p>" });
    chips([{ t: "¿Encaja en mi espacio?", f: function () { S.fuel = p.fuel; askM2(); } }, { t: "Ver alternativas", f: function () { S.fuel = p.fuel; askRoom(); } }]);
  }

  /* ------------- free text */
  var MODELS = [["fla4", "fla4-1490"], ["neo", "neo-1000"], ["prime", "prime-790"], ["vertis", "vertis"], ["arcticon", "arcticon"], ["astro", "astro-1500"], ["aura", "aura"], ["misty", "misty"], ["bubble", "bubble"], ["forma", "forma-1500"], ["faro", "faro"], ["galio", "galio-star"]];
  /* ------------- IA (Claude przez worker fontis-ai, klucz Pedra) */
  var AI_URL = window.FONTIS_AI_URL || "https://fontis-ai.adsfly-aios.workers.dev/chat";
  var AIH = [], aiBusy = false;
  function mdLite(x) { return esc(x).replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>").replace(/\n{2,}/g, "<br><br>").replace(/\n/g, "<br>"); }
  function ctxLine() {
    var b = ["página: " + document.title.split("|")[0].trim()];
    if (S.seg) b.push("perfil: " + S.seg); if (S.room) b.push("espacio: " + S.room); if (S.m2) b.push("superficie: " + S.m2 + " m²");
    if (S.flue) b.push("salida de humos: " + S.flue); if (S.fuel) b.push("tipo: " + S.fuel); if (S.budget) b.push("presupuesto: " + S.budget);
    if (S.recs.length) b.push("ya le propusimos: " + S.recs.join(", "));
    return "[Contexto de la web: " + b.join("; ") + "]\n\n";
  }
  function recCards(ids) {
    var w = document.createElement("div"); w.className = "recs";
    ids.forEach(function (id) {
      var p = byId[id]; if (!p) return;
      var a = document.createElement("a"); a.className = "rec"; a.href = p.url;
      if (p.url[0] === "#") a.addEventListener("click", function (e) { e.preventDefault(); close(); if (window.IFquick) window.IFquick(p.id); });
      a.innerHTML = '<img src="' + p.img + '" alt=""><div><b>' + p.name + '</b><div class="pr">' + (p.frm ? "Desde " : "") + eur(p.price) + "</div><ul><li>" + esc(p.note || "") + "</li></ul></div>";
      w.appendChild(a);
    });
    return w.children.length ? w : null;
  }
  function ai(t) {
    if (aiBusy) return;
    aiBusy = true; input.disabled = true;
    AIH.push({ role: "user", content: ctxLine() + t });
    queue = queue.then(function () { return new Promise(function (res) {
      var typing = document.createElement("div"); typing.className = "typing"; typing.innerHTML = "<i></i><i></i><i></i>"; block(typing);
      var bubble = null, full = "", stop = "";
      function show() {
        var vis = full.split("[[")[0].replace(/\s+$/, ""); if (!vis) return;
        if (!bubble) { typing.remove(); bubble = add("", "bot"); }
        bubble.innerHTML = mdLite(vis); scroll();
      }
      function finish() {
        typing.remove(); aiBusy = false; input.disabled = false;
        if (!full.trim()) { AIH.pop(); legacy(t); res(); return; }
        AIH.push({ role: "assistant", content: full });
        var m = full.match(/\[\[\s*productos?\s*:\s*([^\]]+)\]\]/i);
        if (m) {
          var ids = m[1].split(/[,\s]+/).filter(function (x) { return byId[x]; }).slice(0, 3), el = recCards(ids);
          if (el) { block(el); S.recs = ids.map(function (i) { return byId[i].name; }); }
        }
        if (stop === "error" || stop === "refusal") handoff();
        else if (/\[\[\s*contacto\s*\]\]/i.test(full)) chips([
          { t: "Que me escriban por WhatsApp", f: function () { askLead("WhatsApp"); } },
          { t: "Que me llamen", f: function () { askLead("Teléfono"); } },
          { t: "Por email", f: function () { askLead("Email"); } }], true);
        res();
      }
      fetch(AI_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages: AIH }) }).then(function (r) {
        if (!r.ok || !r.body) throw new Error("ai " + r.status);
        var reader = r.body.getReader(), dec = new TextDecoder(), buf = "";
        function pump() {
          return reader.read().then(function (x) {
            if (x.done) { finish(); return; }
            buf += dec.decode(x.value, { stream: true });
            var parts = buf.split("\n\n"); buf = parts.pop();
            parts.forEach(function (p) {
              if (p.indexOf("data:") !== 0) return;
              try { var d = JSON.parse(p.slice(5)); if (d.t) { full += d.t; show(); } if (d.done) stop = d.stop || ""; } catch (e) {}
            });
            return pump();
          });
        }
        return pump();
      }).catch(function () { finish(); });
    }); });
  }
  function handle(t) {
    var s = t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    clearChips();
    if (S.expect === "m2") { var mm = s.match(/(\d+[.,]?\d*)/); if (mm) return setM2(Math.round(parseFloat(mm[1].replace(",", ".")))); }
    if (S.expect === "budget") { var bb = s.match(/(\d[\d.]*)/); if (bb) { var vv = parseInt(bb[1].replace(/\./g, ""), 10); if (vv < 100) vv *= 1000; S.budget = "~" + eur(vv); S.bmax = vv; return recommend(); } }
    return ai(t);
  }
  function legacy(t) {
    var s = t.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    if (/(sin ventil|ventilaci|sin ventana|cerrad|habitacion pequen|dormitorio pequen|bano|caravana|barco|sin aire|ventilat|no window|windowless|closed room|small room|small bedroom|bathroom|no air|airtight)/.test(s)) return guard();
    if (/(persona|humano|asesor|agente|llamad|llamar|whats|telefono|hablar con|person|human|advisor|adviser|agent|call me|phone|talk to|speak to)/.test(s)) return handoff();
    if (S.expect === "m2") { var m = s.match(/(\d+[.,]?\d*)/); if (m) return setM2(Math.round(parseFloat(m[1].replace(",", ".")))); }
    if (/\bgas\b|butano|propano|glp|butane|propane|lpg/.test(s)) { say("Las chimeneas de gas que vendemos son de exterior y las instala siempre un instalador habilitado (RD 919/2006). Para no darte un dato incompleto, te paso con una persona del equipo técnico."); return handoff(); }
    if (/(consum|gasta|gasto|litro|coste de uso|cuesta usar|por hora|litre|liter|running cost|per hour|how much fuel|use per)/.test(s)) return consumo();
    if (/(segur|peligr|nino|humo|olor|toxic|co2|monoxido|incendi|safe|danger|child|kid|smoke|smell|odour|odor|carbon|fire risk)/.test(s)) return safety();
    if (/(balear|mallorca|ibiza|menorca|formentera|canari|tenerife|palma)/.test(s)) { say("Instalamos en península y Baleares, con fecha cerrada, y te llevamos el bioetanol a casa también en las islas. Canarias: consúltanos (se factura como exportación sin IVA y el IGIC se paga en destino)."); return more(); }
    if (/garant|warrant/.test(s)) { say("Todos los productos tienen 3 años de garantía legal. La gama FLA4 suma hasta 5 años de garantía del fabricante si registras el producto en 30 días."); return more(); }
    if (/(plazo|financ|cuota|al mes|mensual|pagar|instal?ment|monthly|per month|pay over)/.test(s)) { say("El pago a plazos lo estamos preparando. Si te interesa, una persona del equipo te confirma las opciones disponibles."); return handoff(); }
    for (var i = 0; i < MODELS.length; i++) if (s.indexOf(MODELS[i][0]) > -1) return modelInfo(byId[MODELS[i][1]]);
    if (S.expect === "fuel") {
      if (/(bio|etanol|ethanol|real|llama|flame)/.test(s)) { S.fuel = "bioetanol"; return askBudget(); }
      if (/(electr|enchuf|plug)/.test(s)) { S.fuel = "electrica"; return askBudget(); }
      if (/(vapor|agua|water|steam|mist)/.test(s)) { S.fuel = "vapor"; return askBudget(); }
    }
    if (S.expect === "budget") { var b = s.match(/(\d[\d.]*)/); if (b) { var v = parseInt(b[1].replace(/\./g, ""), 10); if (v < 100) v *= 1000; S.budget = "~" + eur(v); S.bmax = v; return recommend(); } }
    if (/(precio|cuanto cuesta|cuanto vale|barat|caro|price|cost|how much|cheap|expensive)/.test(s)) { say("Tenemos desde 389 € (estufa de exterior Faro) hasta proyectos a medida desde 12.299 € con instalación. La mayoría de salones están entre 2.300 y 5.000 €. ¿Te ayudo a acotarlo?"); return askRoom(); }
    if (/(electr)/.test(s)) { S.fuel = "electrica"; say("Las eléctricas Astro solo necesitan un enchufe: llama LED 3D y calefacción de 1,5 o 3 kW."); return askBudget(); }
    if (/(salon|comedor|piso|casa|living|lounge|dining|flat|apartment|house|home)/.test(s) && !S.room) { S.room = "Salón"; return askFlue(); }
    if (/(hola|buenas|hey|hello|\bhi\b|good (morning|afternoon|evening))/.test(s)) { say("¡Hola! Cuéntame tu espacio o elige una opción."); return askRoom(); }
    say("Buena pregunta. Para no darte un dato inexacto, prefiero que te lo confirme una persona del equipo técnico.");
    handoff();
  }
  form.addEventListener("submit", function (e) {
    e.preventDefault(); var t = input.value.trim(); if (!t) return; input.value = ""; me(t); handle(t);
  });
})();
